import React from 'react';
// External components
import { Row } from 'react-simple-flex-grid';
// Internal components
import Tile from '../../common/Tile/Tile.jsx';

const NAME = 'sidebar';
function Sidebar({ products, digitalProducts, digitalText }) {
    const calculateLocation = (product) => {
        let location = product.eventCity;
        if (location && product.eventVenue) {
            location = `${product.eventVenue}, ${product.eventCity}`;
        } else {
            location = product.city;
        }
        return location;
    }

    const renderTile = () => {
        return products.map(product => {
            const location = calculateLocation(product);
            const availableOnline = ! isNaN(product.productTypeId) ? digitalProducts.includes(parseInt(product.productTypeId)) : false;
            return (
                <Tile
                    key={product.productId}
                    src={product.productThumbImgSrc}
                    eyebrow={product.displayName}
                    title={product.pDisplayName}
                    actionUrl={product.productUrl}
                    location={availableOnline ? digitalText : location}
                    bkgColor="white"
                />
            )
        })
    }
    return (
        <Row className={`${NAME}-products`}>
            {products.length == 0 &&
                <div variant="warning">
                    No matching offers for the selected filters were found.
                </div>
            }
            {renderTile()}
        </Row>
    )
}

export default Sidebar;
